import styled from 'styled-components';

export const SwitchLabel = styled.span`
  margin-right: 12px;
  color: var(--text-primary);
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.15rem;
  flex: 1 1 auto;
  min-width: 0;
`;

export const SwitchInput = styled.input.attrs({ type: 'checkbox' })`
  position: relative;
  display: inline-block;
  flex: 0 0 auto;
  width: 48px;
  height: 24px;
  margin: 0;
  background-color: var(--surface-3);
  border: 1px solid var(--border-default);
  border-radius: 12px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:checked {
    background-color: var(--accent);
  }

  &:focus {
    outline: none;
  }

  &:before {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: var(--surface-1);
    box-shadow: var(--shadow-sm);
    transition: transform 0.3s ease;
  }

  &:checked:before {
    transform: translateX(24px);
  }
`;


export const SwitchWrapper = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  font-size: 14px;
  color: var(--text-primary);
  opacity: ${({ $disabled }) => ($disabled ? 0.65 : 1)};
  pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};
`;
